import { render } from "./SurveyStep.vue?vue&type=template&id=06456757&scoped=true"
import script from "./SurveyStep.vue?vue&type=script&lang=js"
export * from "./SurveyStep.vue?vue&type=script&lang=js"

import "./SurveyStep.vue?vue&type=style&index=0&id=06456757&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06456757"]])

export default __exports__